<template>
    <el-dialog width="768px" title="新增" :visible.sync="viewDetail" :append-to-body="true" @close="closeModel">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" style="margin-bottom: 20px">
            <el-form-item label="姓名:" prop="name" :label-width="formLabelWidth">
                <el-input v-model="ruleForm.name" placeholder="请输入姓名" clearable autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="联系方式:" prop="phone" :label-width="formLabelWidth">
                <el-input v-model="ruleForm.phone" placeholder="请输入联系方式" clearable autocomplete="off"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeModel">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { addagent } from "@/api/erweima/index";
export default {
    props: {
        method: {
            type: Function,
        },
    },
    data() {
        return {
            viewDetail: true,
            loading: false,
            ruleForm: {
                name: "",
                phone: "",
            },
            rules: {
                name: [{ required: true, trigger: "blur", message: "请填写名称" }],
                phone: [{ required: true, trigger: "blur", message: "请填写联系方式" }],
            },
            formLabelWidth: "120px",
        };
    },
    mounted() {},
    methods: {
        closeModel() {
            this.$emit("closeModel");
        },
        handleSubmit() {
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    this.getaddagent();
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        },
        getaddagent() {
            this.loading = true;
            let par = {
                token: this.$getSessionStorage("token"),
                rebate_id: this.$getSessionStorage("rebate_id"),
                real_name: this.ruleForm.name,
                cellphones: this.ruleForm.phone,
            };
            addagent(par).then((res) => {
                this.loading = false;
                if (res.code == 1) {
                    this.closeModel();
                    this.method();
                    this.total = parseInt(res.data.count);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
    },
    components: {},
};
</script>

<style scoped lang="scss">
::v-deep .el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 100%;
}
::v-deep .el-select {
    width: 100%;
}

</style>
